import { render, staticRenderFns } from "./UnsavedChangesIndicator.vue?vue&type=template&id=423f2bbe&scoped=true"
import script from "./UnsavedChangesIndicator.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesIndicator.vue?vue&type=script&lang=js"
import style0 from "./UnsavedChangesIndicator.vue?vue&type=style&index=0&id=423f2bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f2bbe",
  null
  
)

export default component.exports